"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isMarkAsReadOptionDirty(state) {
    var savedOptions = state.userOptions;
    var behavior = owa_options_core_1.getFallbackValueIfNull(state.optionState.behavior, savedOptions.PreviewMarkAsRead);
    var delay = owa_options_core_1.getFallbackValueIfNull(state.optionState.delay, savedOptions.MarkAsReadDelaytime);
    return (behavior !== savedOptions.PreviewMarkAsRead ||
        (behavior === 'Delayed' && delay !== savedOptions.MarkAsReadDelaytime));
});
//# sourceMappingURL=isMarkAsReadOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-mark-as-read-option/lib/utils/isMarkAsReadOptionDirty.js
// module id = 5045
// module chunks = 2